import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';
import { cn } from '../../../lib/utils.js';

const BulletContext = createContext(null);
const BulletList = ({ type = "circle", size = "small", children, className }) => {
  return /* @__PURE__ */ jsx(BulletContext.Provider, { value: { type, size }, children: /* @__PURE__ */ jsx(
    "ol",
    {
      className: cn(
        "flex flex-col gap-3 bullet-list",
        size === "smaller" && "gap-1",
        size === "small" && "gap-3",
        size === "medium" && "gap-3",
        type === "number" && "gap-4 step-list",
        className
      ),
      children
    }
  ) });
};
const BulletListItem = ({ color = "basic", children, className = "" }) => {
  const bullet = useContext(BulletContext);
  return /* @__PURE__ */ jsx(
    "li",
    {
      className: cn(
        "relative text-basic-04 pl-4 before:content-[''] before:absolute before:bg-[#666] before:left-[4.5px] whitespace-pre-line break-keep",
        bullet?.type === "circle" && "pl-4 before:rounded-full before:w-[3px] before:h-[3px] before:top-[7.5px] before:left-[4.5px]",
        bullet?.size === "medium" && "body-lg before:top-[9.5px]",
        bullet?.size === "small" && "body-md before:top-[7.6px]",
        bullet?.size === "smaller" && "body-sm pl-3.5 before:top-[6.5px]",
        bullet?.type === "dash" && "before:w-[4px] before:h-[1px] before:left-[4px] before:top-[9px]",
        bullet?.type === "dash" && bullet?.size === "medium" && "before:top-[11px]",
        bullet?.type === "dash" && bullet?.size === "smaller" && "before:top-[7.5px]",
        bullet?.type === "number" && "flex gap-3.5",
        bullet?.type === "info" && "before:content-[] before:absolute before:bg-[url]",
        bullet?.type === "mark" && 'before:content-["※"] before:text-[10px] before:left-[2.6px] before:top-[0.5px] before:bg-[url] before:absolute pl-[18px] before:bg-transparent',
        bullet?.type === "mark" && bullet?.size === "medium" && "before:top-[2px] ",
        bullet?.type === "mark" && bullet?.size === "smaller" && "before:top-[-0.6px] ",
        color === "primary" && "text-primary-04",
        color === "primary" && bullet?.type !== "mark" && "before:bg-icon-primary-04",
        color === "black" && "text-basic-02",
        color === "black" && bullet?.type !== "mark" && "before:bg-icon-basic-02",
        className
      ),
      children: /* @__PURE__ */ jsx("div", { className: cn(bullet?.type === "number" && "pt-1"), children })
    }
  );
};

export { BulletList, BulletListItem };
